<script>
    import { getContext } from "svelte";
    import { t } from "../lang/lang.js";
    import { toCamel } from "../utils.js";

    let options = getContext('options');

    function mount(node) {
        if (options.button_text) {
            node.innerText = options.button_text;
        }

        const styles = [
            'button_width',
            'button_height',
            'button_color',
            'button_background_color',
            'button_font_size',
            'button_font_style',
            'button_font_weight',
            'button_border_radius',
        ];

        styles.forEach(key => {
            if (options[key]) {
                let prop = toCamel(key.substr(7));
                node.style[prop] = options[key];
            }
        });
    }
</script>

<style>
    .arsize_button {
        box-sizing: border-box;
        border-radius: 5px;
        outline: none;
        border: 0;
        font-size: 16px;
        line-height: 16px;
        padding: 10px 12px;
        background-color: #444953;
        color: #fff;
        display: inline-block;
        cursor: pointer;
    }
</style>

<button class="arsize_button" role="button" on:click use:mount>{t('button.default_text')}</button>